module.exports = __webpack_public_path__ + "img/check.4088f1cb.svg";